import React, { useState } from "react";
import { Button, Select, Spin, Table, Typography, Tag, DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title } = Typography;

const LocationDetail = ({
  selectedQRLocationDetail,
  setSelectedQRLocationDetail,
  detailLoading,
  handleLocationClick,
  selectedLocationData,
  setSelectedLocationData,
}) => {
  const [dateRange, setDateRange] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  const handleLocationChange = (locationId) => {
    setSelectedLocationId(locationId);
    handleLocationClick(locationId, dateRange); // <- include date filter
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
    if (selectedLocationId) {
      handleLocationClick(selectedLocationId, dates); // apply date filter
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      {/* Date Range Picker */}
      <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <RangePicker
          format="YYYY-MM-DD"
          onChange={handleDateChange}
          disabledDate={(current) => current && current > dayjs().endOf("day")}
        />
      </div>

      {/* Location Dropdown */}
      <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
        <label style={{ fontWeight: "bold" }}>Select a Location:</label>
        <Select
          style={{ width: "100%", marginTop: "0.5rem" }}
          placeholder="Choose a location"
          onChange={handleLocationChange}
          value={selectedLocationId}
        >
          {selectedQRLocationDetail?.map((loc) => (
            <Option key={loc.id} value={loc.id}>
              {`${loc.apartment_road_area}, ${loc.house_flat_floor_no} — ${loc.city?.name}, ${loc.state?.name}, ${loc.country?.name}`}
            </Option>
          ))}
        </Select>
      </div>

      {/* Content Based on selectedLocationData */}
      {selectedLocationData ? (
        detailLoading ? (
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <Spin />
          </div>
        ) : (
          <>
            {/* Summary */}
            <div className="flex flex-wrap gap-2 mb-4">
              <Tag color="geekblue" className="text-base px-4 py-2 rounded-md font-semibold">
                Total Downloads: {selectedLocationData.total_downloads ?? "-"}
              </Tag>
              <Tag color="cyan" className="text-base px-4 py-2 rounded-md font-semibold">
                Total Orders: {selectedLocationData.total_orders ?? "-"}
              </Tag>
            </div>

            {/* Customer List */}
            {selectedLocationData?.customers?.length > 0 ? (
              <div style={{ marginTop: "2rem" }}>
                <Title level={4}>Customer Details</Title>
                <Table
                  dataSource={selectedLocationData.customers}
                  rowKey={(record, index) => index}
                  pagination={false}
                  bordered
                  scroll={{ x: true }}
                  columns={[
                    {
                      title: "Name",
                      dataIndex: "name",
                      render: (text) => text || "Unregistered User",
                    },
                    {
                      title: "Email",
                      dataIndex: "email",
                      render: (text) => text || "N/A",
                    },
                    {
                      title: "Phone",
                      dataIndex: "phone",
                    },
                    {
                      title: "Total Orders",
                      dataIndex: "total_orders",
                    },
                    {
                      title: "UTM Source",
                      dataIndex: "utm_source",
                      render: (text) => text || "-",
                    },
                    {
                      title: "UTM Medium",
                      dataIndex: "utm_medium",
                      render: (text) => text || "-",
                    },
                    {
                      title: "UTM Campaign",
                      dataIndex: "utm_campaign",
                      render: (text) => text || "-",
                    },
                    {
                      title: "UTM Content",
                      dataIndex: "utm_content",
                      render: (text) => text || "-",
                    },
                  ]}
                />
              </div>
            ) : (
              <div style={{ textAlign: "center", marginTop: "2rem", fontSize: "1.1rem", color: "#888" }}>
                No customers found for this location.
              </div>
            )}
          </>
        )
      ) : (
        <div style={{ textAlign: "center", marginTop: "4rem", fontSize: "1.2rem", color: "#888" }}>
          No data. Please select a location.
        </div>
      )}
    </div>
  );
};

export default LocationDetail;
